import { useEffect } from 'react';
import { Flex } from '../../component-library';
import { PatientFacialDetection } from '../../components';
import { useReceiveMessage } from '../../context/messageContext';
import { kaysOptotypes } from '../../helpers/kaysOptotypes';
import { useOptotypeData } from '../../helpers/reducers';
import Arrow from '../../assets/img/upwards-arrow.svg';

const KaysMultipleOptotypes = () => {
  const receivedMessage = useReceiveMessage();
  const {
    currentOptotypeData: { currentOptotypes, optotypeSize, crowdedOptotype, highlightedOptotype },
    updateOptotypeData,
  } = useOptotypeData();

  useEffect(() => {
    //this receives "reducer" messages and dispatches the appropriate action.
    if (receivedMessage.type === 'useOptotypeReducer') {
      updateOptotypeData({ type: receivedMessage.action, payload: receivedMessage.payload });
    }
  }, [receivedMessage, updateOptotypeData, currentOptotypes]);

  return (
    <Flex>
      <PatientFacialDetection />
      <Flex bg='white' width='100vw' alignItems='center' height='100vh' justifyContent='center'>
        {currentOptotypes.map((opt, idx) => {
          return (
            <Flex
              key={`optotype-${opt}`}
              style={{
                position: 'relative',
                margin: `0 ${currentOptotypes.length > 1 && !crowdedOptotype ? optotypeSize / 2 : 0}px`,
                ...(crowdedOptotype && {
                  borderStyle: 'solid',
                  borderTopWidth: optotypeSize / 8,
                  borderRightWidth: currentOptotypes.length < 2 || idx > 3 ? optotypeSize / 8 : 0,
                  borderBottomWidth: optotypeSize / 8,
                  borderLeftWidth: optotypeSize / 8,
                  padding: optotypeSize / 3,
                }),
              }}
            >
              <Flex width={optotypeSize} height={optotypeSize}>
                {kaysOptotypes[opt]}
              </Flex>

              {highlightedOptotype === opt && (
                <img
                  src={Arrow}
                  alt='arrow highlighting optotype'
                  style={{
                    height: optotypeSize,
                    position: 'absolute',
                    top: `${optotypeSize * (1 + (crowdedOptotype ? 1 : 0.25))}px`,
                    left: '50%',
                    transform: 'translateX(-50%)',
                  }}
                />
              )}
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default KaysMultipleOptotypes;
